import { useMyStore } from "../../../core/auth/useLoggedInUser";
import { useNotificationsByStore } from "../hooks/useNotificationsByStore";
import { MediaListItemMobile } from "../Molecules/MediaListItemMobile";
import { Media, MediaResponse, RoomMedia } from "../types/media";
import { EmptyMediaPlaceholder } from "../Molecules/EmptyMediaPlaceholder";
import { MediaTypes } from "../constants";

interface HomeProps {
  rooms: RoomMedia[];
}

export function Home({ rooms }: HomeProps) {
  const myStore = useMyStore();
  const { data: notifications } = useNotificationsByStore(
    myStore.storeId,
    myStore.countryId
  );

  if (rooms.length === 0) {
    return <EmptyMediaPlaceholder mediaType={MediaTypes.HOME} />;
  }
  return (
    <>
      {rooms.map((room: RoomMedia) => (
        <MediaListItemMobile
          key={room.id}
          mediaResponse={
            { media: room, children: [], parent: {} as Media } as MediaResponse
          }
          taskLinks={notifications?.taskLinks ?? []}
          alerts={notifications?.alerts ?? []}
        />
      ))}
    </>
  );
}
